module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/claims.json
// module id = 355
// module chunks = 137693192098982